<script setup lang="ts">
import SimpleDropdown from "~/components/Common/Dropdowns/SimpleDropdown.vue";

const props = defineProps(["modelValue", "options", "label", "disabled", "placeholder", "redirection", "trackBy"]);
const emit = defineEmits(["update:modelValue"]);

const value = computed({
  get() {
    if (props.modelValue?.templateId) {
      return props.options.find((option: any) => option.templateId === props.modelValue?.templateId);
    }
    return null;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>

<template>
  <div>
    <slot name="header"></slot>
    <SimpleDropdown
      v-model="value"
      class="flex h-[40px] w-full"
      label="name"
      :placeholder="placeholder"
      :delete="false"
      :hide-selected="true"
      :options="options"
      :track-by="trackBy"
      :show-no-options="true"
      no-options
      :disabled="disabled"
    >
    </SimpleDropdown>
  </div>
</template>

<style lang="scss"></style>
